/* eslint-disable */
import { RouteConfig } from 'vue-router';
import { Roles } from '@/modules/authentication/models/rolesEnum';
import Nomenclature from '@/modules/nomenclature/Nomenclature.vue';
import Locations from '@/modules/nomenclature/views/Locations.vue';
import Projects from '@/modules/nomenclature/views/Projects.vue';

const routes: Array<RouteConfig> = [
  {
    path: '/nomenclature',
    name: 'Nomenclature',
    component: Nomenclature,
    redirect: { name: 'Locations' },
    meta: { requiredRole: Roles.admin_edit_nomenclature },
    children: [
      {
        path: '/nomenclature/locations',
        name: 'Locations',
        component: Locations,
        meta: {
          title: 'nomenclature.Locations.metaTitle'
        }
      },
      {
        path: '/nomenclature/projects',
        name: 'Projects',
        component: Projects,
        meta: {
          title: 'nomenclature.Projects.metaTitle'
        }
      }
    ]
  }
];

export default routes;
